import React from 'react';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getIsMemberNavigatable, getProfileLinkTemplate, } from '../../../common/store/ma-navigation/ma-navigation-selectors';
import { MEMBER_SLUG_PARAM } from '../../../common/store/ma-navigation/constants';
const ProfileLink = ({ member, className, children, tabIndex }) => {
    const { navigateToMember, isMemberNavigatable, profileLinkTemplate } = useApi((state, actions) => ({
        navigateToMember: actions.navigateToMember,
        isMemberNavigatable: getIsMemberNavigatable(state, member === null || member === void 0 ? void 0 : member.id),
        profileLinkTemplate: getProfileLinkTemplate(state),
    }));
    const { resourceId } = useConfiguration();
    const handleProfileNavigation = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (member) {
            navigateToMember(member.id, member.profile.slug, resourceId);
        }
    };
    const buildProfileLink = () => (member === null || member === void 0 ? void 0 : member.profile.slug)
        ? profileLinkTemplate.replace(MEMBER_SLUG_PARAM, member === null || member === void 0 ? void 0 : member.profile.slug)
        : '';
    return (React.createElement(React.Fragment, null, isMemberNavigatable ? (React.createElement("a", { className: className, style: { cursor: 'pointer' }, onClick: handleProfileNavigation, href: buildProfileLink(), tabIndex: tabIndex }, children)) : (React.createElement("div", { tabIndex: 0, className: className }, children))));
};
export default ProfileLink;
//# sourceMappingURL=profile-link.js.map